module.exports = __webpack_public_path__ + "img/icon-star-filled.fcaa296e.svg";